var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2403 8.03487L25.6147 10.6604L30.4189 15.4833H11.4813V19.2075H30.4189L25.6147 24.0118L28.2403 26.656L37.5508 17.3454L28.2403 8.03487ZM4.03282 4.31065H18.9297V0.586426H4.03282C1.98449 0.586426 0.308594 2.26233 0.308594 4.31065V30.3802C0.308594 32.4285 1.98449 34.1044 4.03282 34.1044H18.9297V30.3802H4.03282V4.31065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.84198ec98af9e2e7dcc7a3b9986fc8d6.svg";
export { ForwardRef as ReactComponent };